import { render, staticRenderFns } from "./emergency.vue?vue&type=template&id=48b442a6&scoped=true&"
import script from "./emergency.vue?vue&type=script&lang=js&"
export * from "./emergency.vue?vue&type=script&lang=js&"
import style0 from "./emergency.vue?vue&type=style&index=0&id=48b442a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b442a6",
  null
  
)

export default component.exports